import React, { useContext, useState } from "react";
import {
  PostPurchaseContext,
  PostPurchaseDispatchContext,
} from "../../context/PostPurchaseContext";
import FormCheckbox from "../FormCheckbox";
import BackButton from "../BackButton";

function Step4() {
  const state = useContext(PostPurchaseContext);
  const dispatch = useContext(PostPurchaseDispatchContext);

  async function handleNext() {
    if(!state.policy || !state.termsCondition) {
      return
    }
    await submitFormData();
    dispatch({ type: "setActiveStep", payload: 5 });
  }

  async function submitFormData() {
    await addItemsToCart();
    await sendDataToKlaviyo();
  }

  async function addItemsToCart() {
    const { extendedWarranty, kit, filters } = state.cart;
    const items = [];
    await fetch("/cart/clear.js");
    if (extendedWarranty) {
      items.push({
        id: extendedWarranty,
        quantity: 1,
        properties: {
          post_purchase_flow: "true",
          serialNumber: state.serialNumber,
        },
      });
    }

    if (kit) {
      items.push({
        id: kit.productId,
        quantity: 1,
        selling_plan: kit.sellingPlanId,
        properties: {
          post_purchase_flow: "true",
        },
      });
    }
    if (filters) {
      filters.forEach((filter) => {
        items.push({
          id: filter.productId,
          quantity: 1,
          selling_plan: filter.sellingPlanId,
          properties: {
            post_purchase_flow: "true",
          },
        });
      });
    }

    if (items.length > 0) {
      const cartData = {
        items: items,
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartData),
      });
      await response.json();
    }
  }

  async function sendDataToKlaviyo() {
    const { firstName, lastName, email, phoneNumber, emailNotifications, smsNotifications, klaviyoListId } = state;

    const options = {
      method: 'POST',
      headers: {revision: '2023-02-22', 'content-type': 'application/json'},
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: klaviyoListId,
            email: email,
            phone_number: phoneNumber,
            properties: {
              firstName: firstName,
              lastName: lastName,
              emailConsent: emailNotifications,
              smsConsent: smsNotifications 
            }
          }
        }
      })
    };
    
    try {
      const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=MkQWdR', options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      console.log({ response });
    } catch (error) {
      console.error('Error:', error);
    }    
  }

  return (
    <>
      <div className="text-center">
        <div className="px-12">
          <div className="flex items-center pb-2.5">
            <FormCheckbox
              label="I agree with the Privacy Policy."
              name="policy"
            />
            <a
              href="https://briowater.com/policies/privacy-policy"
              className="text-[12px] text-left border-b-brio-300 border-b border-solid before:content-['*'] before:text-brio-300"
            >
              Privacy Policy
            </a>
          </div>
          <div className="flex items-center pb-2.5">
            <FormCheckbox
              label="I have read and agree with the Brio."
              name="termsCondition"
            />
            <a
              href="https://briowater.com/policies/terms-of-service"
              className="text-[12px] text-left border-b-brio-300 border-b border-solid before:content-['*'] before:text-brio-300"
            >
              Terms & Condiditions
            </a>
          </div>
        </div>
        <div class="button-wrapper">
        <BackButton isLoading={false} text="Back" />
        <button
          className={`px-[52px] py-[18px] bg-brio-300 text-white rounded-[16px] font-bold text-3xl mx-auto mt-8 ${
            state.policy && state.termsCondition ? "" : "opacity-20"
          }`}
          onClick={handleNext}
          disabled={!state.policy || !state.termsCondition}
        >
          Submit
        </button>
        </div>
      </div>
    </>
  );
}

export default Step4;
